export function conditional<T>(condition: boolean | undefined | null, content: T): T | undefined {
  return condition ? content : undefined;
}

export function makeTestId(...parts: Array<string | undefined>): string {
  return parts.join('-');
}

export function isAlphabeticChar(char: string): boolean {
  return !!char && /^[a-z0-9]$/i.test(char);
}
